import { Icon } from '@distribusion/owl-frontend-ui'
import cn from 'classnames'
import React, { ReactElement } from 'react'

import config from '@config'
import useIsMobile from '@hooks/useIsMobile'
import amplitude from '@lib/analytics/amplitude'
import { useParams } from '@stores/params'

import '@components/WhatsappButton/index.scss'

interface WhatsappButtonProps {
  phoneNumber: string
}

const WhatsappButton = ({ phoneNumber }: WhatsappButtonProps): ReactElement => {
  const [{ retailerPartnerNumber }] = useParams()
  const isMobile = useIsMobile()
  const styles = {
    width: '40px',
    height: '40px',
    opacity: 0.6,
    bottom: '90px',
  }
  return (
    <a
      data-tag="whatsapp-button"
      href={`https://api.whatsapp.com/send?phone=${phoneNumber}`}
      className={cn('whatsapp-button')}
      target="_blank"
      rel="noreferrer"
      style={config.customGEBUI.byRPN.includes(retailerPartnerNumber) && isMobile ? styles : {}}
      onClick={amplitude.clickWhatsappButton}
    >
      <Icon name="whatsapp" size="large" />
    </a>
  )
}

export default WhatsappButton
